import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import * as React from 'react';

export function SvgExternalLink() {
  return <LinkExternalIcon label="" testId="ads-refreshed-icon" />;
}
